"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalTime = exports.getLocalWeekday = exports.getLocalDayGroup = void 0;
var moment_1 = __importDefault(require("moment"));
require("moment-timezone");
/**
 * Get the time now in Bangkok time.
 */
function getLocalDate(offsetDays) {
    var time = moment_1.default.tz('Asia/Phnom_Penh').add(offsetDays, 'days');
    return time;
}
/**
 * Get the local date string in the yyyy-MM-DD format.
 *
 * @param offsetDays The number of days after the time now.
 */
function getLocalDayGroup(offsetDays) {
    if (offsetDays === void 0) { offsetDays = 0; }
    return getLocalDate(offsetDays).format('yyyy-MM-DD');
}
exports.getLocalDayGroup = getLocalDayGroup;
/**
 * Retrieves the day of the week as a number.
 */
function getLocalWeekday(offsetDays) {
    if (offsetDays === void 0) { offsetDays = 0; }
    return getLocalDate(offsetDays).days();
}
exports.getLocalWeekday = getLocalWeekday;
/**
 * Retrieves the current UTC date information for statistics.
 */
function getLocalTime(offsetDays) {
    if (offsetDays === void 0) { offsetDays = 0; }
    return {
        weekday: getLocalWeekday(offsetDays),
        hours: getLocalDate(offsetDays).hours(),
        date: getLocalDayGroup(offsetDays),
    };
}
exports.getLocalTime = getLocalTime;
